import React, { useState } from "react";
import "./Navbar.css";
import img3 from "../assets/images.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import SideBarNav from "./SidebarNav";
import { logOutUser } from "../redux/reducer";


const NavContainer = styled.div`
  height: 50px;
  display: flex;
  width: 100%;
  background-color: darkgreen;
  padding: 10px;
`;
const NavBar = styled.div`
  display: flex;
  width: 100%;
`;
const NavList = styled.div`
  display: flex;
  width: 100%;
`;
//
const NavListRight = styled.div`
  display: flex;
  position: absolute;
  right: 20px;
  justify-content: end;
`;

const ImgProfile = styled.img`
  width: 20px;
  border-radius: 10px;
`;

const Navbar = () => {
  
  const user = useSelector((state) => state.userName);

  const [isOpen, setIsopen] = useState(false);
  const dipatch = useDispatch();
  const navigate = useNavigate();

  const handlelogout = () => {
    logOutUser();
    navigate("/logreg");
  };

  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };

  return (
    <>
      <NavContainer>
        <NavBar>
          <NavList>
            <div className="togglebar" onClick={ToggleSidebar}>
              <i className="fa fa-bars"></i>
            </div>
            <div className="title">E-Learning</div>

            <NavListRight>
              <div>
                <ImgProfile src={img3} />
                <span> {user}</span>
              </div>
            </NavListRight>
          </NavList>
        </NavBar>

        <div className={`sidebar ${isOpen == true ? "active" : ""}`}>
          <div className="closeSidebarButton" onClick={ToggleSidebar}>&#215;</div>
          <SideBarNav></SideBarNav>
        </div>
        <div
          className={`sidebar-overlay ${isOpen == true ? "active" : ""}`}
          onClick={ToggleSidebar}
        ></div>
      </NavContainer>
    </>
  );
};

export default Navbar;
